// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__2wSbp","title":"Card_title__Ip0in","content":"Card_content__1AEDp"};